var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-form',{ref:"form",attrs:{"url":"role","edit":_vm.edit,"items":_vm.items,"beforeRequest":_vm.beforeRequest},on:{"success":function($event){return _vm.$emit('success')}}})}
var staticRenderFns = []

export { render, staticRenderFns }